export const GET_USER = 'Dyzio/UserHandler/GET_USER';
export const GET_USER_SUCCESS = 'Dyzio/UserHandler/GET_USER_SUCCESS';
export const GET_USER_ERROR = 'Dyzio/UserHandler/GET_USER_ERROR';



/** WEBPACK FOOTER **
 ** ./src/containers/user-handler/constants.js
 **/